export const colorPriority0 = '#65E0AC';
export const colorPriority1 = '#DCFCEF';
export const colorPriority2 = '#F0F39E';
export const colorPriority3 = '#FDD5B8';
export const colorPriority4 = '#F07A7A';
export const colorPriority5 = '#9B6969';
